/**
 * Pull the API's real error message out of an axios rejection.
 * Shared by components that surface backend messages in toasts
 * (previously duplicated in PhoneNumberCard + TaxInfoFormCard).
 *
 * Reads the canonical nested envelope first ({ error: { message } }),
 * falls back to the legacy flat `message` field for older servers
 * (DESIGN_ApiErrorHumanization.md §5.1).
 */
export function apiErrorMessage(err: unknown, fallback: string): string {
  const data = (err as {
    response?: { data?: { error?: { message?: string }; message?: string } }
  })?.response?.data
  return data?.error?.message ?? data?.message ?? fallback
}

/** Machine-readable error code from the envelope (e.g. 'TIER_GATE_BLOCKED'). */
export function apiErrorCode(err: unknown): string | undefined {
  const data = (err as { response?: { data?: { error?: { code?: string } } } })?.response?.data
  return data?.error?.code
}

/** Correlation id echoed by the API — link frontend reports to backend logs/Sentry. */
export function apiErrorRequestId(err: unknown): string | undefined {
  const data = (err as { response?: { data?: { error?: { requestId?: string } } } })?.response?.data
  return data?.error?.requestId
}
